import {create} from 'zustand';
import { customerFeedbackData } from '../api_layer/api';
import { summaryUser } from '../api_layer/api';



const useEngSummaryStore = create((set) => ({
  summaryData: [],
  summaryUser:[],
  isLoading: false,
  error: null,
  fetchSummaryData: async (sd,ed,sd1,ed1, queryParams) => {
    try {
      set({ isLoading: true, error: null });
      const response = await customerFeedbackData(sd,ed, sd1,ed1, queryParams);
      set({ summaryData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchUserData: async (sd,ed,sd1,ed1) => {
    try {
      set({ isLoading: true, error: null });
      const response = await summaryUser(sd,ed, sd1,ed1);
      set({ summaryUser: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
}))

export default useEngSummaryStore;